export const tableHeading = [
  { label: "DONOR NAME", className: "donor-name" },
  { label: "TRIBUTE TYPE", className: "donor-type" },
  { label: "TRIBUTE NAME", className: "donor-name" },
  {
    label: "DATE",
    className: "donor-date",
    align: "left",
    sortable: true,
  },
  { label: "CAUSE", className: "donor-cause" },
  {
    label: "AMOUNT",
    className: "donor-amount",
    align: "left",
  },
  { label: "PAPER", className: "donor-paper", align: "left" },
  { label: "SENT", className: "donor-sent", align: "left" },
];

export const displayStatus = (status) => {
  return (
    status?.replaceAll("_", " ")?.charAt(0).toUpperCase() +
    status?.replaceAll("_", " ")?.slice(1)
  );
};

export const getIdsSelected = (check) => check?.map((el) => el?._id);
